// Adresse de la page web du jeu : celle que le QR code de la carte de partage encode, que le lien copié ou partagé contient, et vers laquelle mène le lien
// « Installer l'appli » des fenêtres de charge. C'est une configuration, pas l'adresse de la page ouverte : on mène toujours à la page officielle, où qu'on joue
// (appli installée, test, preflight…). Pour une autre adresse, construire ou lancer avec VITE_GAME_URL (ex. `VITE_GAME_URL=http://localhost:5173/ npm run dev`, ou
// une ligne dans un fichier .env). En développement, une adresse de loopback est remplacée par celle du réseau local (voir ui/shareModal.js) pour scanner depuis un téléphone.
export const DEFAULT_GAME_URL = 'https://apps.0cog.com/zero-kami/';

/** Adresse http(s) valide, sinon l'adresse par défaut. @param {unknown} value */
export function resolveGameUrl(value) {
  if (typeof value !== 'string' || value.trim() === '') return DEFAULT_GAME_URL;
  try {
    const url = new URL(value.trim());
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : DEFAULT_GAME_URL;
  } catch {
    return DEFAULT_GAME_URL;
  }
}

export const GAME_URL = resolveGameUrl(import.meta.env?.VITE_GAME_URL);
